import type { Patient } from '@/types/patient';

export interface ApiPatient {
  username: string;
  name: {
    first_name: string;
    middle_name?: string;
    last_name: string;
  };
  birthday?: string;
  apiToken?: string;
  activities: unknown[];
}

export function hasAnalyzedStream(activity: unknown): boolean {
  if (!activity || typeof activity !== 'object') return false;
  const streamIds = (activity as { streamIds?: unknown }).streamIds;
  if (!Array.isArray(streamIds)) return false;
  return streamIds.some((id) => typeof id === 'string' && id.toLowerCase() === 'analyzed');
}

function toPatient(apiPatient: ApiPatient, activities: unknown[]): Patient {
  return {
    id: apiPatient.username,
    username: apiPatient.username,
    firstName: apiPatient.name.first_name,
    lastName: apiPatient.name.last_name,
    middleName: apiPatient.name.middle_name,
    dateOfBirth: apiPatient.birthday,
    apiToken: apiPatient.apiToken,
    activities,
    totalActivities: activities.length,
    status: activities.length > 0 ? 'active' : 'inactive',
  };
}

export function transformPatient(apiPatient: ApiPatient): Patient {
  return toPatient(apiPatient, (apiPatient.activities || []).filter(hasAnalyzedStream));
}

export function transformPatientAll(apiPatient: ApiPatient): Patient {
  return toPatient(apiPatient, apiPatient.activities || []);
}
